export default {"src":"/_next/static/media/walletConnect.028d96fd.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};